import { gql } from "@apollo/client"

export const GET_ORGANIZATIONS = gql`
  query getOrganizations($data: OrganizationListInput!) {
    getOrganizations(data: $data) {
      organizations {
        id
        name
        type
        states
        sf_id
        districtCount
        orgAdminCount
      }
    }
  }
`

export const GET_ORGANIZATIONS_COUNT = gql`
  query getOrganizationsCount($data: OrganizationsCountInput!) {
    countOrganizations(data: $data) {
      total
      active
    }
  }
`

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization($data: OrganizationCreateInput!) {
    createOrganization(data: $data) {
      id
      name
      type
      states
      sf_id
    }
  }
`

export const UPDATE_ORGANIZATION = gql`
  mutation updateOrganization($data: OrganizationUpdateInput!) {
    updateOrganization(data: $data) {
      id
      name
      type
      states
      sf_id
    }
  }
`

export const DELETE_ORGANIZATION = gql`
  mutation deleteOrganization($data: OrganizationDeleteInput!) {
    deleteOrganization(data: $data) {
      id
    }
  }
`

export const DELETE_ORGANIZATIONS = gql`
  mutation deleteOrganizationBatch($data: OrganizationDeleteBatchInput!) {
    deleteOrganizationBatch(data: $data)
  }
`
